import React from 'react';
import './AboutModal.css';

const AboutModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="about-overlay" onClick={onClose}>
      <div className="about-content" onClick={(e) => e.stopPropagation()}>
        
        {/* HEADER */}
        <div className="about-header">
          <h2 className="about-brand">FIORI</h2>
          <p className="about-tagline">Dar con sentido</p>
        </div>

        {/* BODY */}
        <div className="about-body">
          <section className="about-section">
            <h3>Propósito</h3>
            <p>En fiori creemos que regalar flores es mucho más que un gesto: es una forma de expresar lo que somos y lo que sentimos. Todo acto de dar nace de una intención, y ahí comienza el verdadero valor de un detalle.</p>
            <p className="about-italic">¿Desde dónde nace ese deseo?, ¿qué quiero expresar?, ¿hacia quién va realmente dirigido?, y ¿cómo debo mentalizarme para hacerlo con autenticidad?</p>
            <p>Promovemos una cultura de dar con sentido, donde cada acción contribuya a una sociedad más consciente, empática y conectada.</p>
          </section>

          <div className="about-grid">
            <section className="about-section">
              <h3>Visión</h3>
              <p>Aportar al cambio de la sociedad, construyendo un mundo donde los detalles tengan significado y estén guiados por la belleza, la intención y la claridad.</p>
            </section>
            <section className="about-section">
              <h3>Misión</h3>
              <p>Compartir la sabiduría que encontramos en la vida a través de las flores y del arte de dar, creando experiencias que transmitan emociones reales y generen impacto en las personas.</p>
            </section>
          </div>

          <section className="about-section">
            <h3>Valores</h3>
            <ul className="values-list">
              <li><strong>Intención:</strong> Todo nace desde un propósito genuino.</li>
              <li><strong>Autenticidad:</strong> Dar desde lo que realmente somos.</li>
              <li><strong>Belleza:</strong> Cuidar cada detalle como una forma de expresión.</li>
              <li><strong>Claridad:</strong> Comunicar con sentido y coherencia.</li>
              <li><strong>Conexión:</strong> Fortalecer relaciones humanas a través del acto de dar.</li>
            </ul>
          </section>

          <section className="philosophy-box">
            <h3>Filosofía</h3>
            <p>Creemos firmemente que todo lo que damos debe nacer de nosotros mismos para que tenga una intención verdadera. Cuando damos con propósito, lo que ofrecemos florece, transforma y tiene el poder de cambiar el mundo.</p>
          </section>
        </div>

        {/* FOOTER */}
        <div className="about-footer">
          <button className="close-about-btn" onClick={onClose}>
            Cerrar
          </button>
        </div>

      </div>
    </div>
  );
};

export default AboutModal;